jQuery( document ).ready( function() {
	let chimpFamily = '';
	let chimpPersonality = '';
	let chimpMinAge = '';
	let chimpMaxAge = '';
	let paged = 1;
	let checkkey = true;
	chimpFamily = jQuery( '#ajax-family-slected-value' ).data( 'slug' ) ?? '';
	chimpMinAge = jQuery( '#ajax-age-slected-value' ).data( 'minage' ) ?? '';
	chimpMaxAge = jQuery( '#ajax-age-slected-value' ).data( 'maxage' ) ?? '';
	function updateThePermalink() {
		if ( history.pushState ) {
			const oldUrl = window.location.protocol + '//' + window.location.host + window.location.pathname;

			// Extract base URL without the page number
			let baseUrl = oldUrl.replace( /\/page\/\d+\/$/, '' );

			if ( chimpFamily !== '' && chimpPersonality !== '' ) {
				baseUrl += `?family=${ chimpFamily }&personality=${ chimpPersonality }`;
			} else if ( chimpFamily !== '' ) {
				baseUrl += `?family=${ chimpFamily }`;
			} else if ( chimpPersonality !== '' ) {
				baseUrl += `?personality=${ chimpPersonality }`;
			}

			// Add age parameters if needed
			if ( chimpMinAge !== '' && chimpMinAge !== undefined && chimpMaxAge !== '' && chimpMaxAge !== undefined ) {
				if ( baseUrl.includes( '?' ) ) {
					baseUrl += `&min-age=${ chimpMinAge }&max-age=${ chimpMaxAge }`;
				} else {
					baseUrl += `?min-age=${ chimpMinAge }&max-age=${ chimpMaxAge }`;
				}
			}

			if ( paged ) {
				if ( baseUrl.includes( '?' ) ) {
					baseUrl += `&current-paged=${ paged }`;
				} else {
					baseUrl += `?current-paged=${ paged }`;
				}
			}

			window.history.pushState( { path: baseUrl }, '', baseUrl );
		}
	}

	jQuery( '.chimp-ajax-page' ).on( 'click', function() {
		jQuery( 'html, body' ).animate(
			{
				scrollTop: jQuery( '#scroll-to-here' ).offset().top - 180,
			},
			2000
		);
		paged = jQuery( this ).data( 'page' );
		sendAjaxRequest();
		updateThePermalink();
	} );
	jQuery( 'li #ajax-family-click' ).on( 'click', function() {
		chimpFamily = jQuery( this ).data( 'slug' );
		paged = 1;
		sendAjaxRequest();
		updateThePermalink();
	} );
	jQuery( 'li #ajax-personality-click' ).on( 'click', function() {
		chimpPersonality = jQuery( this ).data( 'slug' );
		paged = 1;
		sendAjaxRequest();
		updateThePermalink();
	} );
	jQuery( '#ajax-age-click div' ).on( 'click', function() {
		chimpMinAge = jQuery( this ).data( 'minage' );
		chimpMaxAge = jQuery( this ).data( 'maxage' );
		paged = 1;
		sendAjaxRequest();
		updateThePermalink();
	} );
	function sendAjaxRequest() {
		jQuery.ajax( {
			url: localVars.ajax_url,
			type: 'POST',
			data: {
				action: 'chimp_post_filter',
				chimpFamily,
				chimpPersonality,
				chimpMinAge,
				chimpMaxAge,
				paged,
			},
			success( response ) {
				if ( response ) {
					jQuery( '#chimp-post-container' ).empty();
					jQuery( '#chimp-post-container' ).html( response.html );
					jQuery( '#ajax-chimp-pagination-container' ).empty();
					jQuery( '#ajax-chimp-pagination-container' ).html( response.pagination );
					if ( checkkey ) {
						jQuery( document ).on( 'click', '.chimp-ajax-page', function() {
							jQuery( 'html, body' ).animate(
								{
									scrollTop: jQuery( '#scroll-to-here' ).offset().top - 180,
								},
								2000
							);
							paged = jQuery( this ).data( 'page' );
							sendAjaxRequest();
							updateThePermalink();
							checkkey = false;
						} );
					}
				}
			},
		} );
	}
} );
